

export const FETCH_EXAM_CODES = "[RECEPTIONIST] FETCH_EXAM_CODES";
export const FETCH_EXAM_CODES_START = "[RECEPTIONIST] FETCH_EXAM_CODES_START";
export const FETCH_EXAM_CODES_SUCCESS = "[RECEPTIONIST] FETCH_EXAM_CODES_START_SUCCESS";
export const FETCH_EXAM_CODES_ERROR = "[RECEPTIONIST] FETCH_EXAM_CODES_ERROR";


export const fetchAllExamCodes = () => {
    return {
        type: FETCH_EXAM_CODES,
        payload: null
    }
}